import './house-mosaic.scss';
